import type { FunctionComponent } from 'react';

import logoBlack from 'Assets/images/logo-black.svg';
import logoWhite from 'Assets/images/logo-white.svg';
import { Themes } from 'Consts/themes';
import { useSelectUserTheme } from 'User/data';

import { StyledApplicationLogo } from './ApplicationLogo.styles';

type Props = {
  className?: string;
};

export const ApplicationLogo: FunctionComponent<Props> = ({ className }) => {
  const currentTheme = useSelectUserTheme();

  return (
    <StyledApplicationLogo
      src={currentTheme === Themes.dark ? logoWhite : logoBlack}
      className={className}
    />
  );
};
